import React from 'react'
import IndustrySector from '../industryComponents/IndustrySector'
import IndustryDesign from '../industryComponents/IndustryDesign'
import HomeTab from '../../home/HomeTab'
import HomeResource from '../../home/HomeResource'
import SustainabilityBanner from '../../sustainability/SustainabilityBanner'
import DynamicBreadcrumb from '../../../components/DynamicBreadcrumb'
import IndustryInvest from '../industryComponents/IndustryInvest'
import IndustryServe from '../industryComponents/IndustryServe'

const breadcrumbData = [
  {
    slug: "/",
    page: "Home",
  },
  {
    slug: "",
    page: "Industries",
  },
  {
    slug: "",
    page: "Government Services",
  },
];

const bannerData = {
  img:"assets/images/govermentservice-industry-banner.webp",
  leftHead:"Government Services",
  rightHead:"Bringing Structure and Accountability to Public Records",
  desc:"Government operations depend on accuracy, transparency, secure access to critical records. Dox and Box enables public sector organizations to manage large volumes of documents with precision, ensuring secure storage, streamlined workflows, instant retrieval to support efficient and accountable service delivery."
}

const sectorData ={
  head:"Sector Overview",
  overview:"Government bodies handle vast amounts of sensitive information, including citizen records, administrative files, legal documents, policy archives. Dox and Box provides secure, scalable, compliance-ready solutions that help government organizations improve efficiency, strengthen governance, ensure seamless access to information when needed."
}

const designData = {
  head:"Tailored Solutions for Government Services",
  img:"/assets/images/goverment-service-industry-design.webp",
  desc:[
    "We specialize in delivering structured and secure document management systems designed to meet the complex requirements of public sector operations. Our solutions ensure every record is organized, accessible, aligned with regulatory standards.",
    "With a deep understanding of government workflows, we help departments reduce manual effort, improve turnaround times, maintain better control over critical information."
  ],
  list:[
    "Secure repositories for citizen records and official documentation",
    "Access-controlled environments for protected information sharing",
    "Efficient search capabilities for quick document access",
    "Governance-focused records and archive management",
    "Digitized workflows to simplify administrative tasks",
    "Adaptive systems built to manage increasing record volumes",
  ]
}

const tabData = [
  {
    icon: "/assets/images/home-tab-icon-1.webp",
    title: "Physical Records & Archive Management",
    heading:"Secure, Structured, Scalable Physical Record Storage",
    desc:"Managing physical documents doesn’t have to mean cluttered offices or lost files. At Dox and Box, we offer end-to-end physical records management designed to keep your documents secure, accessible, fully compliant. Our state-of-the-art archival facilities are built with strict security protocols, environmental controls, fire safety systems.",
    slug:"/physical-records-management-services",
    image:"/assets/images/home-tab-image-1.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-2.webp",
    title: "Scanning & Digitization Services",
    heading:"Transform Paper Documents into Searchable Digital Assets",
    desc:"Move beyond manual paperwork with high-precision scanning and digitization services. We convert your physical records into structured, searchable, easily accessible digital formats. Using advanced scanning technology and intelligent indexing, we ensure every document is accurately captured and categorized.",
    slug:"/digitization-services",
    image:"/assets/images/home-tab-image-2.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-3.webp",
    title: "Intelligent Document Processing & AI-driven Extraction",
    heading:"Unlock Data from Documents with AI-Powered Intelligence",
    desc:"Turn unstructured documents into actionable data with our AI-driven document processing solutions. We leverage advanced technologies like machine learning, OCR, natural language processing to extract, classify, validate information automatically. From invoices and contracts to forms and reports, our system reduces manual effort, minimizes errors, accelerates workflows. ",
    slug:"/ai-document-data-extraction",
    image:"/assets/images/home-tab-image-3.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-4.webp",
    title: "Data Governance & Compliance Platform (SaaS)",
    heading:"Ensure Compliance, Control, Visibility Across Your Data",
    desc:"In today’s regulatory landscape, managing data securely and compliantly is critical. Our SaaS-based data governance platform provides centralized control over your documents, ensuring they are stored, accessed, managed in line with industry regulations. With role-based access, audit trails, retention policy automation, businesses gain complete visibility and control over their data.",
    slug:"/data-privacy-governance-compliance-platform",
    image:"/assets/images/home-tab-image-4.webp"
  },
]


const investData = {
  head:"Why Government Organizations Need Smart Document Management?",
  boxes:[
    {
      img:'/assets/images/goverment-service-industry-invest-1.webp',
      icon:"/assets/images/goverment-service-industry-invest-icon-1.webp",
      title:"Efficient Record Management",
      desc:"Centralizes public records for easy access and organization.",
    },
    {
      img:'/assets/images/goverment-service-industry-invest-2.webp',
      icon:"/assets/images/goverment-service-industry-invest-icon-2.webp",
      title:"Regulatory Compliance",
      desc:"Ensures adherence to policies, audits, legal requirements.",
    },
    {
      img:'/assets/images/goverment-service-industry-invest-3.webp',
      icon:"/assets/images/goverment-service-industry-invest-icon-3.webp",
      title:"Faster Citizen Services",
      desc:"Speeds up approvals, applications, service delivery.",
    },
    {
      img:'/assets/images/goverment-service-industry-invest-4.webp',
      icon:"/assets/images/goverment-service-industry-invest-icon-4.webp",
      title:"Reduced Paperwork",
      desc:"Minimizes manual processes and physical storage needs.",
    },
    {
      img:'/assets/images/goverment-service-industry-invest-5.webp',
      icon:"/assets/images/goverment-service-industry-invest-icon-5.webp",
      title:"Secure Data Handling",
      desc:"Protects sensitive government and citizen information with advanced security measures.",
    },
    {
      img:'/assets/images/goverment-service-industry-invest-6.webp',
      icon:"/assets/images/goverment-service-industry-invest-icon-6.webp",
      title:"Improved Transparency",
      desc:"Enables better tracking, accountability, governance across all departments.",
    },
  ]
}

const serveData = {
  head:"Other Industries We Serve",
  boxes:[
    {
      img:"/assets/images/insurance-industry-serve-2.webp",
      title:"Healthcare Services",
      desc:"Healthcare services require precision, security, seamless access to critical records.",
      slug:"/healthcare"
    },
    {
      img:"/assets/images/other-industry-serve-2.webp",
      title:"Media & Entertainment ",
      desc:"Media & entertainment demands speed, organization, seamless access to high-volume content assets.",
      slug:"/media-entertainment-records-management"
    },
  ]
}

export default function GovernmentServices() {
  return (
    <>
      <DynamicBreadcrumb breadcrumbData={breadcrumbData} />
      <SustainabilityBanner data={bannerData} />
      <IndustrySector data={sectorData} />
      <IndustryDesign data = {designData}/>
      <HomeTab tabData={tabData}/>
      <HomeResource/>
      <IndustryInvest data = {investData}/>
      <IndustryServe data={serveData}/>
    </>
  )
}
